import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { TextTitle } from '@bingads-webui-campaign/wizard-jumbo-card';
import { Label, Stack, Toggle } from '@bingads-webui-react/fabric-control';
import { withCustomValidation } from '@bingads-webui-react/validation';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ActivityContext } from '@bingads-webui-react/hoc-with-signal';

const Title = ({ titleKey }) => {
  const i18n = useContext(I18nContext);
  const titleText = i18n.getString(titleKey);

  return (
    <Stack verticalAlign="center" horizontal tokens={{ childrenGap: 8 }}>
      <Label className="collapse-title" >
        {titleText}
      </Label>
    </Stack>
  );
};

Title.propTypes = {
  titleKey: PropTypes.string.isRequired,
};

const NewCustomerAcquisitionHeader = ({ validationProps, updateValidation }) => {
  const { data: { newCustomerAcquisitionOptOut } } = validationProps;
  const activity = useContext(ActivityContext);

  const onToggleChange = (e, checked) => {
    updateValidation([], { newCustomerAcquisitionOptOut: !checked });
    if (activity) {
      activity.signal(`onNewCustomerAcquisitionChanged - isNewCustomerAcquisitionEnabled: ${checked}`);
    }
    e.stopPropagation();
  };

  return (
    <Stack verticalAlign="center" horizontal tokens={{ childrenGap: 8 }}>
      <Toggle
        className="nca-toggle"
        inlineLabel={false}
        styles={{
          root: {
            marginTop: '3px',
            marginBottom: '0px',
          },
        }}
        checked={!newCustomerAcquisitionOptOut}
        onChange={onToggleChange}
      />
      <TextTitle
        titleKey={_TL_('Optimize for new customer acquisition')}
        topicKey="pop_BA_PMAX_CustomerAcquisition"
      />
    </Stack>
  );
};

NewCustomerAcquisitionHeader.propTypes = {
  validationProps: PropTypes.shape({
    data: PropTypes.shape({
      newCustomerAcquisitionOptOut: PropTypes.bool,
    }),
  }).isRequired,
  updateValidation: PropTypes.func.isRequired,
};


export const ValidatedNewCustomerAcquisitionHeader = withCustomValidation(NewCustomerAcquisitionHeader);
